import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.BackToTop = class BackToTop extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-back-to-top';
	}
	
	constructor(element) {
		super(element);
	}

	setVars() {
		this.$backToTopButton = this.$element.find('.fa-back-to-top__button');
	}

	addEventListeners() {
		this.$backToTopButton.on('click', this.onBackToTopButtonClick.bind(this));
	}

	render() {
		this.setVars();
		this.addEventListeners();
	}

	onBackToTopButtonClick() {
		$('body, html').animate({ scrollTop: 0 }, 800);
	}
};



// WEBPACK FOOTER //
// ./components/backToTop/scripts/backToTop.js